<template>
  <component 
    :is="itDepends"
    :tx-date="txDate"
    :source="source"
    :name="name"
    :icsType="sbu"
    :area="transaction.area"
    :tx-type="transaction.tx_type"
    :price-feet="priceFeet"
    :price-total="priceTotal"
    :stock-link="stockLink"
    :stock-search-button="stockSearchButton"
  ></component>
</template>

<script>
import * as moment from 'moment';
import numberFormat from '@/mixins/numberFormat';
import ListItemCell from '@/components/Transaction/ListItemCell';
import ListItemBox from '@/components/Transaction/ListItemBox';

export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    buildingPage: {
      type: Boolean,
      default: false,
    },
    stockSearchButton: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [numberFormat],
  components: {
    ListItemCell,
    ListItemBox,
  },
  computed: {
    itDepends() {
      if (this.$md.mobile() && !this.$md.tablet()) {
        return 'list-item-box';
      }
      return 'list-item-cell';
    },
    txDate() {
      if (this.buildingPage) {
        return this.transaction.txDate ?
          moment(this.transaction.txDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
      }
      return this.transaction.tx_date ?
        moment(this.transaction.tx_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
    },
    name() {
      return this.$i18n.locale === 'en' ? this.transaction.name.en : this.transaction.name.zh;
    },
    area() {
      return this.transaction.area;
    },
    priceTotal() {
      return this.transaction.tx_type === 'S' ?
        this.formatBigNumber(this.transaction.sell) :
        this.fmt(this.transaction.rent, 0, 3, ',');
    },
    priceFeet() {
      if (this.transaction.tx_type === 'S') {
        return this.transaction.ft_sell === 0 ?
          '-' :
          `$${this.fmt(this.transaction.ft_sell, 0, 3, ',')}`;
      }
      return this.transaction.ft_rent === 0 ?
        '-' :
        `$${this.fmt(this.transaction.ft_rent, 0, 3, ',')}`;
    },
    source() {
      let source = '';
      switch (this.transaction.upload_source) {
        case 'CMI':
        case 'EPRC':
        case 'Daybook':
        case 'Search':
        case 'REGISTERY':
          source = this.$t('transaction.REGISTERY');
          break;
        case 'Unicorn Info':
        case 'Land Register':
          source = this.$t('transaction.LAND_REGISTER');
          break;
        case 'MIDLAND':
          source = this.$t('transaction.MIDLANDICI_INFO');
          break;
        default:
          source = this.$t('transaction.MARKET_INFO');
          break;
      }
      return source;
    },
    stockLink() {
      const keyword = this.transaction.keyword.searchText;

      let stockLink = `${window.SITE_URL}find/`;
      switch (this.transaction.icsType) {
        case 'i':
          stockLink = `${stockLink}industrial/`;
          break;
        case 'c':
          stockLink = `${stockLink}office/`;
          break;
        case 's':
          stockLink = `${stockLink}shops/`;
          break;
        default:
          break;
      }
      return `${stockLink}?keywords=${keyword}`;
    },
    sbu() {
      if (this.transaction.icsType === 'ics') {
        return this.transaction.ics_type;
      }
      return this.transaction.icsType;
    },
  },
  methods: {
  },
};
</script>

<style scoped>


</style>
